import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import CloseIcon from 'static/images/close.svg';
import styles from './Modal.css';

/**
 * Modal component
 * @param {any} children the children prop
 * @param {className} className custom class name to override the default styles
 * @param {string} modalRoot target element id to render the modal component
 * @param {boolean} showModal modal state (true or false)
 * @param {string} title title of the modal
 * @param {Function} onCLose a callback to be called when the modal is closed
 * @param {boolean} hideCloseButtonLabel whether to hide the close button label (true or false) defaults to true
 }}
 * @returns 
 */
function Modal(props) {
  const {
    children,
    className,
    modalRoot = 'modal-root',
    showModal,
    title,
    onClose,
    hideCloseButtonLabel = false,
  } = props;

  const overlayRef = useRef(null);

  const handleCloseModal = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const handleOverlayClick = e => {
    if (overlayRef.current && overlayRef.current === e.target) {
      handleCloseModal();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOverlayClick, false);
    return () => {
      document.removeEventListener('mousedown', handleOverlayClick);
    };
  });

  return showModal
    ? ReactDOM.createPortal(
        <div ref={overlayRef} className={styles.overlay}>
          <div className={`${styles.modal} ${className}`}>
            <div className={styles.header}>
              <span>{title}</span>
              <button
                type="button"
                className={styles.closeButton}
                onClick={handleCloseModal}
              >
                {!hideCloseButtonLabel ? (
                  <span className={styles.closeButtonLabel}>Close</span>
                ) : null}
                <CloseIcon />
              </button>
            </div>
            <div className={styles.body}>{children}</div>
          </div>
        </div>,
        document.getElementById(modalRoot),
      )
    : null;
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/components/Modal/Modal.jsx